import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Offcanvas, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addCompanyContact } from "../../../store/actions/Companies/companyActions";
import { debounce } from "../../../utils/debounce";
import { get, post } from "../../../services/api";

const AddContactLog = forwardRef((props, ref) => {
  const [isLoading, setIsloading] = useState(false)
  const [formData, setFormData] = useState({
    contactPersonId: props?.contactPersonId,
  });

  const resetForm = () => {
    setFormData({
      "action":"",
      "date":"",
      "duration":"",
      "subject":"",
      "time":"",
      contactPersonId: props?.contactPersonId,
    });
    setErrors({});
  };
  

  const [errors, setErrors] = useState({});
  const [addContact, setAddContact] = useState(false);

  useImperativeHandle(ref, () => ({
    showContactModal() {
      resetForm();
      setAddContact(true);
    },
  }));

  
  const validate = () => {

    const newErrors = {};

    const requiredFields = [
      "action",
      "date",
      "subject",
      "time"
    ];
    requiredFields.forEach((field) => {
      if (field === "date" && !formData[field]) {
        newErrors[field] = "Date is required.";
      }

      if(field !== "date" && !formData[field]) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
      }
    });


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please fill all the required fields.");
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (validate()) {
      setIsloading(true);
      await post('/api/contact-log', formData, props.token);
          resetForm();
          setAddContact(false);
          props.getLogs();
          setIsloading(false);
          toast.success("Contact log saved!");
    }
  };

  return (
    <>
      <Offcanvas
        show={addContact}
        onHide={() => {
          resetForm();
          setAddContact(false);
        }}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header">
          <h5 className="modal-title" id="#gridSystemModal">
            {props.Title}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              resetForm();
              setAddContact(false);
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {[
                  {
                    label: "Action",
                    field: "action",
                    type: "select",
                    required: true,
                    options: ["Appointment", "Booking Confirmed Email Sent", "Booking Confirmed Letter Sent", "Call"],
                  },
                  
                  { label: "Contact Date", field: "date", type:"date", required: true },
                  { label: "Contact Time", field: "time", type:"time", required: true },
                  { label: "Duration", field: "duration"},
                  { label: "Subject", field: "subject", required: true },
                  
                  
                ].map(
                  ({
                    label,
                    field,
                    type = "text",
                    required = false,
                    options = [],
                    disabled = false,
                  }) => (
                    <div className="col-xl-6 mb-3" key={field}>
                      {type === "select" ? (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <select
                            className="form-control"
                            value={formData[field]}
                            disabled={disabled}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            {options?.map((itm) => (
                              <option value={itm}>{itm}</option>
                            ))}
                          </select>
                        </>
                      ) : type === "date" ? (
                        <>
                        <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                        <DatePicker
                              dateFormat="dd/MM/yyyy"
                              className="form-control"
                              selected={formData[field]}
                              disabled={disabled}
                              onChange={(date) =>
                                handleInputChange(field,date)
                              }
                        />
                        </>) : (
                        <>
                          <label className="form-label">
                            {label}{" "}
                            {required && <span className="text-danger">*</span>}
                          </label>
                          <input
                            type={type}
                            className="form-control"
                            value={formData[field]}
                            disabled={disabled}
                            onChange={(e) =>
                              handleInputChange(field, e.target.value)
                            }
                          />
                         
                        </>
                      )}

                      {errors[field] && (
                        <small className="text-danger">{errors[field]}</small>
                      )}
                    </div>
                  )
                )}

              <div className="col-xl-12 mb-3" >
              <label className="form-label">
                            Details
                          </label>
                          <textarea
                          
                            className="form-control"
                            value={formData?.details}
                            rows={15}
                            onChange={(e) =>
                              handleInputChange("details", e.target.value)
                            }
                          />
              </div>
                
              </div>
              <div>
                <button type="submit" className="btn btn-primary me-1">

                  {isLoading ? <Spinner  size="sm"/> : 'Submit'}
                </button>
                <Link
                  to={"#"}
                  onClick={() => {
                    resetForm();
                    setAddContact(false);
                  }}
                  className="btn btn-danger light ms-1"
                >
                  Cancel
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default AddContactLog;
